import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
// import "./genderpage.css";
// import "./Home.scss"
import NavBar from "../components/NavBar/NavBar.jsx";
import Body from "../components/HomePage/Body.jsx";
import VideoSection from "../components/HomePage/VideoSection.jsx";
import Footer from "../components/Footer/Footer.jsx";
import usePersonaStore from "../Store/PersonaStore.jsx";
import useAuthStore from "../Store/AuthStore.jsx";
// import { fetchIPAndGeolocation } from "../Services/IPGeoHandler.jsx";
// import axios from "axios";

const HomePage = () => {
  const { setSelectedPersona, fetchUserPersonas } = usePersonaStore();
  const { isAuthenticated } = useAuthStore();

  // Deselect all personas when navigating to home page and fetch if authenticated
  useEffect(() => {
    setSelectedPersona(null);
    if (isAuthenticated) {
      fetchUserPersonas();
    }
  }, [setSelectedPersona, fetchUserPersonas, isAuthenticated]);

  return (
    <div>
      <NavBar />
      {/* <fetchIPAndGeolocation /> */}
      <Body />
      <VideoSection />
      <Footer />
    </div>
  );
};

export default HomePage;
